import { css } from "@emotion/react";
import { rem } from "polished";
import React from "react";
import { Link } from "react-router-dom";

import { Left, NavLI, NavLink, NavMenu } from "../../base";
import { useChainId } from "../../modules/hooks";

const HeaderLeft = () => {
  const chainId = useChainId();
  return (
    <Left
      css={css`
        flex: 0 0 auto;
        width: 25%;
      `}
    >
      <NavMenu>
        <NavLI>
          <NavLink
            as={Link}
            css={css`
              position: relative;
              white-space: nowrap;
            `}
            to="/"
          >
            Capacity{" "}
            {!chainId ||
              (chainId !== 1 && (
                <span
                  css={css`
                    /* position: absolute;
                left: ${rem(32)};
                top: ${rem(46)}; */

                    /* font-size: ${rem(16)}; */
                    /* font-size: ${rem(16)}; */
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.4);
                  `}
                >
                  on Sepolia Testnet
                </span>
              ))}
          </NavLink>
        </NavLI>
      </NavMenu>
    </Left>
  );
};

export default HeaderLeft;
